"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createElement = exports.appendNodeAsync = void 0;

var _utils = require("./utils");

var resetLoadHandlers = function resetLoadHandlers(node, onload, onerror) {
  return function () {
    node.onload = onload;
    node.onerror = onerror;
  };
};

var appendNodeAsync = function appendNodeAsync(target, node, resolveCallback) {
  return new Promise(function (resolve, reject) {
    var resetHandlers = resetLoadHandlers(node, node.onload, node.onerror);
    node.onload = (0, _utils.handleWith)(resetHandlers, node.onload, function () {
      return resolve(typeof resolveCallback === 'function' ? resolveCallback() : undefined);
    });
    node.onerror = (0, _utils.handleWith)(resetHandlers, node.onerror, target.removeChild.bind(target, node), function () {
      return reject(new Error("Couldn't load ".concat(node.rel || node.tagName, " by url: ").concat(node.href || node.src)));
    });
    target.appendChild(node);
  });
};

exports.appendNodeAsync = appendNodeAsync;

var createElement = function createElement(tagName, nodeProps) {
  return Object.assign(global.document.createElement(tagName), nodeProps);
};

exports.createElement = createElement;